import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Divider,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Stack,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TablePagination,
  Card
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import parse from "html-react-parser";
import axios from "axios";
import { ReactComponent as DeleteIcon } from "../../../Icons/DeleteTable.svg";
import { ReactComponent as EditIcon } from "../../../Icons/EditIcon.svg";
import AlertModal from "../../../CommonComponents/AlertModal";
import LinearProgress from '@mui/material/LinearProgress';
import CachedIcon from '@mui/icons-material/Cached';
import VisibilityIcon from '@mui/icons-material/Visibility';
import dayjs from 'dayjs'
import {useDispatch, useSelector} from 'react-redux'
import axiosInstance from '../../../api/axiosInstance'
import { removeData } from "../../../Redux/Feature/AdminSlice";

export default function DentalBookings() {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const admin = useSelector((state) => state.AdminData.admin);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [bookedService, setBookedService] = useState({})

  let deleteData = {
    label: "Confirm Delete Service",
    descriptionOne: "Please confirm that you wish to delete the Service.",
    buttonOne: {
      variant: "outlined",
      color: "#0E5E84",
      backgroundColor: "#FFFFFF",
      text: "Cancel",
    },
    buttonTwo: {
      variant: "contained",
      color: "#FFFFFF",
      backgroundColor: "#912018",
      text: "Confirm",
    },
  };

  const [hostelData, setHostelData] = useState([]);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [deleteModal, setDeleteModal] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const getAllHostel = async () => {
    setLoading(true)
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/get-all-dental-bookings/?page=${
            page + 1
          }&limit=${rowsPerPage}`
      );
      console.log(response);
      setHostelData(response?.data?.data || []);
      setTotalItems(response.data.pagination.totalItems || 0)
      setLoading(false)
    } catch (error) {
      console.log(error);
      setLoading(false)
      if(error.response.status === 401){
        navigate('/login')
        dispatch(removeData())
    }
    }
  };

  const ApproveDecline = async (status, id) => {
        try {
            const response = await axiosInstance.post(`/dental-booking-approve-decline/${id}`, {status })
            if(response.status === 200){
                getAllHostel()
                setOpen(false)
            }
        } catch (error) {
            console.log(error)
        }
  }

  const handleClose = () => {
    setDeleteModal(null);
    setDeleteId(null);
  };

  const deleteHostel = async () => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}delete-booked-servic/${deleteId}`
      );
      getAllHostel();
      setDeleteModal(null);
      setDeleteId(null);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllHostel();
  }, [page, rowsPerPage]);


  const handleSeeMore = (description) => {
    setSelectedDescription(description);
  };


  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when rows per page change
  };


  const FileDisplayCard = ({ bookedService, name, heading }) => {

    const images = bookedService?.form_data?.[name];
  
    if (!images || !Array.isArray(images)) return null;
  
    return images.map((file, index) => {
      const fileUrl = `/${file.path.replaceAll("\\", "/")}`;
      const isImage = file.mimetype?.startsWith("image");
  
      return (
        <Card key={index} sx={{ mt: 2, p: 2 }}>
          <Typography fontWeight="bold">{heading}</Typography>
  
          {isImage ? (
            <img
              src={`${process.env.REACT_APP_FILE_PATH}${file.filename}`}
              alt={file.originalname}
              style={{ maxWidth: "100%", marginTop: 8, borderRadius: 8 }}
            />
          ) : (
            <iframe
              src={`${process.env.REACT_APP_FILE_PATH}${file.filename}`}
              title={file.originalname}
              style={{ width: "100%", height: "300px", border: "1px solid #ccc", marginTop: 8 }}
            ></iframe>
          )}
        </Card>
      );
    });
  };


  return (
    <>
      
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h7_1">Dental Bookings</Typography>

        <Box sx={{display : 'flex', gap : 3, alignItems : 'center'}}>
        <Typography variant="h7_1" sx={{cursor : 'pointer'}} title='Reload' onClick={() => getAllHostel()}><CachedIcon /></Typography>
        {/* <Button
          onClick={() => navigate("/Admin/add-common-service")}
          variant="contained"
        >
          Add
        </Button> */}
        </Box>
       
      </Stack>
      
      <TableContainer sx={{
        mt : 3.5,
          borderRadius: "5px",
          border: "1px solid #e5e5e5",
          boxShadow: "0px 0px 30px 20px #f4f4f4",
        }}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
            <TableCell sx={{ borderBottom: "0.5px solid #dcdddc", py: 2.7 }}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Booked Time
                </Typography>
              </TableCell>
              <TableCell sx={{ borderBottom: "0.5px solid #dcdddc", py: 2.7 }}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Student Name
                </Typography>
              </TableCell>
              <TableCell sx={{ borderBottom: "0.5px solid #dcdddc", py: 2.7 }}>
                <Typography variant="h9_1" color="#333333">
                  Dental Name
                </Typography>
              </TableCell>
              <TableCell sx={{ borderBottom: "0.5px solid #dcdddc", py: 2.7 }}>
                <Typography variant="h9_1" color="#333333">
                 Approoval Status
                </Typography>
              </TableCell>
              <TableCell sx={{ borderBottom: "0.5px solid #dcdddc", py: 2.7 }}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Date and Time
                </Typography>
              </TableCell>
              <TableCell sx={{ borderBottom: "0.5px solid #dcdddc", py: 2.7 }}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Actions
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {loading && (
              <TableRow>
                <TableCell colSpan={5} sx={{p :0, borderBottom : '0px'}}>
              <LinearProgress color="primary" />
              </TableCell>
              </TableRow>
            )}

            {hostelData.length == 0 ? (<>
              <TableRow>
              <TableCell colSpan={5} sx={{borderBottom: "0.5px solid #dcdddc", py: 2.7}}>
            {!loading && (
            <Typography>No data found</Typography>
            )}
            </TableCell>
            </TableRow>
            </>) : (
            hostelData.map((item, index) => (
              <TableRow
                key={item.name}
                sx={{border: "0px",
                backgroundColor: index % 2 === 0 ? "#f8f8f8" : "white"}}
              >
                <TableCell sx={{ minWidth: "200px", borderBottom: "0.5px solid #dcdddc" }}>
                <Typography variant="h9_4" color="#333333">
                      {dayjs(item?.form_data?.arrival_date).format("DD/MM/YYYY hh:mm A") || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={{ minWidth: "200px", borderBottom: "0.5px solid #dcdddc" }}>
                <Typography variant="h9_4" color="#333333">
                    {item?.form_data?.name || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={{ minWidth: "200px", borderBottom: "0.5px solid #dcdddc" }}>
                  <Typography variant="h9_4" color="#333333">
                    {item?.dental_name || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={{ minWidth: "200px", borderBottom: "0.5px solid #dcdddc",  }}>
                    <Typography>{item?.approoval_status}</Typography>
                </TableCell>
                <TableCell sx={{ minWidth: "200px", borderBottom: "0.5px solid #dcdddc" }}>
                  <Typography variant="h9_4" color="#333333">
                    {dayjs(item?.createdAt).format("DD/MM/YYYY hh:mm A") || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={{ minWidth: "200px", borderBottom: "0.5px solid #dcdddc" }}>
                  <IconButton
                    onClick={() => {
                        setBookedService(item)
                        setOpen(true)
                        
                    }}
                    sx={{ marginRight: "10px" }}
                  >
                    <VisibilityIcon />
                  </IconButton>
                  {/* <IconButton
                    onClick={() => {
                      setDeleteId(item._id);
                      setDeleteModal(true);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton> */}
                </TableCell>
              </TableRow>
            )))}
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={totalItems} 
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />

      </TableContainer>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Dental Booking Details</DialogTitle>
        <Divider></Divider>
        <DialogContent>
        <Card sx={{mt : 2, p : 2}}>
            <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Name</Typography>
                <Typography>{bookedService?.form_data?.name}</Typography>
            </Box>

            <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Phone</Typography>
                <Typography>{bookedService?.form_data?.phone}</Typography>
            </Box>

            <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Email</Typography>
                <Typography>{bookedService?.form_data?.email}</Typography>
            </Box>
        </Card>

        <Card sx={{mt : 2, p : 2}}>
            <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Line</Typography>
                <Typography>{bookedService?.form_data?.line}</Typography>
            </Box>

            <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>WeChat</Typography>
                <Typography>{bookedService?.form_data?.wechat}</Typography>
            </Box>

            <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Whatsapp</Typography>
                <Typography>{bookedService?.form_data?.whatsapp}</Typography>
            </Box>
        </Card>

           

            {bookedService?.voucher_code && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Voucher Code</Typography>
                <Typography>{bookedService?.voucher_code}</Typography>
            </Box>
            )}


            {bookedService?.form_data?.arrival_date && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Arrival Date</Typography>
                <Typography>{dayjs(bookedService?.form_data?.arrival_date).format("DD/MM/YYYY hh:mm A")}</Typography>
            </Box>
            )}

            {/* <Box sx={{display : 'flex', alignItems : 'center', gap : 2, justifyContent : 'flex-end'}}>
                <Button onClick={() => ApproveDecline("Approved", bookedService?._id)} variant='contained'>Approve</Button>
                <Button onClick={() => ApproveDecline("Declined", bookedService?._id)} sx={{backgroundColor : 'red'}} variant='contained'>Decline</Button>
            </Box> */}
   

        
        </DialogContent>
        <Divider></Divider>
        <DialogActions>
          <Button
            onClick={() => setOpen(false)}
            color="primary"
            variant="contained"
            sx={{ margin: "10px", padding: "10px 20px" }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
